// extracted by mini-css-extract-plugin
export default {"container":"UserForm_container__JFaEf","actions-container":"UserForm_actions-container__QryOH"};